import { Button, DatePicker, Input, message, Select } from "antd";
import { useFormik } from "formik";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  AddUserAdvance,
  addUserAdvance,
  UpdateUserAdvance,
  updateUserAdvance,
  userAdvanceFields,
} from "../../actions/advances";

const { Option } = Select;

const AddAdvance = (props) => {
  const dispatch = useDispatch();
  const userAdvanceFieldsResponse = useSelector(
    (state) => state.advances.userAdvanceFields || {},
  );
  const addUserAdvanceResponse = useSelector(
    (state) => state.advances.addUserAdvance,
  );
  const editRes = useSelector((state) => state.advances.updateUserAdvance);
  const { data: { response: { fields = [] } = {} } = {} } =
    userAdvanceFieldsResponse;

  const [validationSchema, setValidationSchema] = React.useState(null);
  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (vals) => {
      let arr = [];
      Object.keys(vals).forEach((ele) => {
        arr.push({
          id: ele,
          value: vals[ele],
        });
      });
      props.advanceData?.id
        ? dispatch(
          updateUserAdvance({ field_values: arr, id: props.advanceData?.id }),
        )
        : dispatch(addUserAdvance({ field_values: arr }));
    },
  });

  const callOnMount = () => {
    if (props.advanceData?.id) {
      dispatch(userAdvanceFields({ id: props.advanceData?.id }));
    } else {
      dispatch(userAdvanceFields());
    }
  };

  React.useEffect(() => {
    callOnMount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const { data: { status = false } = {} } = addUserAdvanceResponse;
    if (status) {
      formik.resetForm();
      dispatch({ type: AddUserAdvance.RESET });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUserAdvanceResponse]);

  React.useEffect(() => {
    if (fields && fields?.length > 0 && props.advanceData?.id) {
      let arr = {};
      fields.forEach((item) => {
        arr[item.field_id] =
          item.field_type === "dropdown" && item.selected.id
            ? item.selected.id
            : item.selected.value;
      });
      formik.setValues({
        ...arr,
      });
    }

    if (fields && fields?.length) {
      let obj = {};
      let obj2 = {};
      fields.forEach((item) => {
        if (item.is_required && item.field_id !== "payment_method") {
          obj2[item.field_id] = "";
          obj[item.field_id] = Yup.string().required(
            `${item.display_name} is required`,
          );
        }
      });
      if (!props.advanceData?.id)
        formik.setValues({
          ...obj2,
          ...formik.values,
        });
      setValidationSchema(Yup.object().shape(obj));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userAdvanceFieldsResponse]);

  React.useEffect(() => {
    if (editRes?.data?.status) {
      handleCancelButton();
      callOnMount();
      dispatch({
        type: UpdateUserAdvance.RESET,
      });
    }

    if (editRes?.data?.status === false) {
      dispatch({
        type: UpdateUserAdvance.RESET,
      });
    }
    // eslint-disable-next-line
  }, [editRes]);
  const handleCancelButton = () => {
    formik.resetForm();
    props.handleCancel();
  };

  const handleChange = (val, id) => {
    formik.setFieldValue(id, val);
  };

  const renderDataTypes = (value, default_values, id, display_name) => {
    switch (value) {
      case "string":
        return (
          <>
            <Input
              placeholder={`Enter ${display_name}`}
              value={formik.values?.[id]}
              style={{ minWidth: "216px" }}
              onChange={(e) => {
                handleChange(e.target.value.trimStart(), id);
              }}
            />
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      case "integer":
        return (
          <>
            <Input
              placeholder={`Enter ${display_name}`}
              type="text"
              value={formik.values?.[id]}
              style={{ minWidth: "216px" }}
              onChange={(e) => {
                if (Number.isNaN(Number(e.target.value))) {
                  return;
                }
                handleChange(e.target.value.trimStart(), id);
              }}
            />
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      case "dropdown":
        return (
          <>
            <Select
              style={{ width: 200 }}
              placeholder="Select"
              value={formik.values?.[id]}
              onChange={(val) => {
                handleChange(val, id);
              }}
            >
              {default_values &&
                default_values.map(({ id, value }) => (
                  <Option key={id} value={id}>
                    {value}
                  </Option>
                ))}
            </Select>
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      case "datetime":
        return (
          <>
            <DatePicker
              value={
                formik.values?.[id]
                  ? moment(formik.values?.[id], [
                    "DD MMM'YY, HH:mm:ss a",
                    "YYYY-MM-DD HH:mm:ss",
                  ])
                  : null
              }
              onChange={(date, dateString) => {
                handleChange(dateString, id);
              }}
              showTime
            />
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      default:
      // code block
    }
  };

  return (
    <>
      <form className="modal-form" onSubmit={formik.handleSubmit}>
        {fields.length &&
          fields.map(
            (item) =>
              item.field_id !== "payment_method" && (
                <div className="nameItem">
                  <label
                    className={`inline-block ${item.is_required ? "required" : ""}`}
                  >
                    {item.display_name}
                  </label>
                  <br />
                  {renderDataTypes(
                    item.field_type,
                    item.default_values,
                    item.field_id,
                    item.display_name,
                  )}
                </div>
              ),
          )}
        <div>
          <Button
            key="1"
            htmlType="submit"
            className="formButton mt3 primaryButton"
            disabled={addUserAdvanceResponse?.loading}
          >
            Submit
          </Button>
          <Button
            key="2"
            htmlType="button"
            className="cancelButton ml1 mt3 "
            onClick={() => handleCancelButton()}
          >
            Cancel
          </Button>
        </div>
      </form>
    </>
  );
};

export default AddAdvance;
